export default __webpack_public_path__ + "3d017a4e96a3b07db37d2c279f9cdccf.png";